module.exports = __webpack_public_path__ + "img/fashion_88.cb3001e8.jpg";